import { Add, Remove } from "@mui/icons-material";
import { Box, TextField } from "@mui/material";
import PropTypes from "prop-types";

function Counter({ counter, increment, decrement, label, handleChange, helperText, variant }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: ".1rem",
        "& .MuiFormHelperText-root": { color: "#d32f2f", margin: "0px" },
        flex: "1",
      }}
    >
      <Remove
        onClick={decrement}
        sx={{
          cursor: "pointer",
          marginTop: variant === "standard" && !helperText ? "15px" : "-15px",
          marginRight: variant === "standard" && "5px",
        }}
      />
      <TextField
        type="number"
        sx={{
          "& input[type=number]": {
            MozAppearance: "textfield",
          },
          "& input[type=number]::-webkit-outer-spin-button": {
            WebkitAppearance: "none",
          },
          "& input[type=number]::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
          },
          input: {
            textAlign: "center",
          },
        }}
        label={label || "Count"}
        onChange={handleChange}
        value={counter}
        helperText={helperText}
        variant={variant}
        onMouseEnter={(e) =>
          e.target.addEventListener("wheel", (event) => {
            event.preventDefault();
          })
        }
      />
      <Add
        onClick={increment}
        sx={{
          cursor: "pointer",
          marginTop: variant === "standard" && !helperText ? "15px" : "-15px",
          marginLeft: variant === "standard" && "5px",
        }}
      />
    </Box>
  );
}

Counter.defaultProps = {
  counter: 0,
  increment: () => {},
  decrement: () => {},
  label: "",
};

Counter.propTypes = {
  counter: PropTypes.number,
  increment: PropTypes.func,
  decrement: PropTypes.func,
  label: PropTypes.string,
};

export default Counter;
